import './index.css'
import Button from '../button'
import Logo from '../logo'

function Header({ CTA, URLForLogo, functionForButton, stateManipulator, CTA2, functionForButton2, context }) {
    return (
        <div className="header" id={context ? context + "-header" : null}>
            <Logo url={URLForLogo} />
            <div id="nav-button-holder" style={{ display: CTA || CTA2 ? 'flex' : 'none' }}>
                {CTA2 && (
                    <Button
                        image='./images/add-post.png'
                        id="secondary-cta"
                        text={CTA2}
                        addedFunction={functionForButton2}
                        stateManipulator={stateManipulator}
                    />
                )}
                {CTA && (
                    <Button
                        image='./images/add.png'
                        text={CTA}
                        id="primary-cta"
                        addedFunction={functionForButton}
                        stateManipulator={stateManipulator}
                    />
                )}
            </div>
        </div>
    )
}

export default Header